import Acoustic from './Acoustic';
import Banjo from './Banjo';
import Bass from './Bass';
import Electric from './Electric';
import Mandolin from './Mandolin';
import Ukulele from './Ukelele';

type SvgProps = React.SVGProps<SVGElement>;

// tslint:disable:object-literal-key-quotes
const mappings: { key: string, url: string, value: React.StatelessComponent<SvgProps>}[] = [
    { key: 'Electric', url: '/inventory/category/electric-guitars', value: Electric },
    { key: 'Acoustic', url: '/inventory/category/acoustic-guitars', value: Acoustic },
    { key: 'Bass', url: '/inventory/category/basses', value: Bass },
    { key: 'Banjo', url: '/inventory/category/banjos', value: Banjo },
    { key: 'Mandolin', url: '/inventory/category/mandolins-and-mandolin-family', value: Mandolin },
    { key: 'Ukulele', url: '/inventory/category/ukuleles-taropatches-and-tiples', value: Ukulele }
];

export default mappings;



// WEBPACK FOOTER //
// ./src/components/global/application/svg_components/index.ts